export default __webpack_public_path__ + "static/media/opening.f12b1f09.ogg";